import { FkGasAndShop } from 'common'
import { reducerDatabase, actionsDatabase } from '../util'

type Base = FkGasAndShop
export type State = Base[]

export enum ActionTypes {
  ADD = '@@fkGSSList/ADD',
  ADDS = '@@fkGSSList/ADDS',
  REMOVE = '@@fkGSSList/REMOVE',
  REMOVES = '@@fkGSSList/REMOVES',
  SET_LIST = '@@fkGSSList/SET_LIST',
  UPDATE = '@@fkGSSList/UPDATE',
  UPDATES = '@@fkGSSList/UPDATES',
}

const actionDB = actionsDatabase<Base>(ActionTypes)

export const actions = {
  /**
   * FKGSS 추가
   */
  addFKGSS: actionDB.add,
  addFKGSSs: actionDB.adds,
  /**
   * FKGSS 삭제
   */
  removeFKGSS: actionDB.remove,
  removeFKGSSs: actionDB.removes,
  /**
   * FKGSS List 셋팅
   */
  setFKGSSList: actionDB.setList,
  /**
   * FKGSS 업데이트
   */
  updateFKGSS: actionDB.update,
  updateFKGSSs: actionDB.updates,
}

export const initialState: State = []

export const reducer = reducerDatabase(initialState, ActionTypes)
